import Image from "next/image";
import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { TLink } from "@/components/molecules/Button";
import { useBudouX } from "@/hooks/useBudouX";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Contact from "@/components/organisms/Contact";
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { VoiceCover } from "@/components/organisms/VoiceCover";
import { VoiceNav } from "@/components/organisms/VoiceNav";
import voicePhoto from "/public/voice-photo4.webp";
import voicePhotoB from "/public/voice-photo4b.webp";

export default function CareerArticle4(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={
          "Voices:メンバーの声 No.4 課題と向き合うことで感じた成長の実感"
        }
        pageDescription={
          "株式会社トッカシステムズのVoices:メンバーの声 No.4 課題と向き合うことで感じた成長の実感。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/careers/voice/4"}
      />
      <Layout className="relative">
        <div className="absolute z-0 aspect-1/1 w-full bg-voices-no4 xs:max-h-[300px] sm:max-h-[300px] md:aspect-1/1 md:max-h-[500px] lg:max-h-[640px]"></div>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Careers",
                  path: "/",
                },
                {
                  name: "Voices:メンバーの声 No.4",
                },
              ]}
            />
            <Inner className="max-w-full">
              <div className="mx-auto flex max-w-6xl flex-col">
                <VoiceCover
                  title="課題と向き合うことで感じた成長の実感"
                  avatar="M.Rさん - 2019年入社"
                />
                <figure className="relative mt-6 block aspect-2/1 w-full group-hover:opacity-80 md:mt-8 lg:mt-10">
                  <Image
                    src={voicePhoto}
                    alt="課題と向き合うことで感じた成長の実感 M.Rさん - 2019年入社"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </figure>
              </div>
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>
                  ToccaSystemsに入った時の印象を教えてください。
                </Interviewer>
                <Interviewee>
                  私はIT未経験で入社したので、一番最初は本当にわからない状態でした。先輩の設計書をみて、色々覚えていったりしていました。
                </Interviewee>
                <Interviewer>
                  ToccaSystemsの好きなところはどこですか？
                </Interviewer>
                <Interviewee>
                  成長の機会があるところです。週1で新しい技術を習得するための社内勉強会が開かれているのですが、課題が出て、発表するんです。2チームに分かれて、調べて、結果発表したり。新しい技術も学べるし、課題のために自分で調べることも多く、自発性がすごく身につきました！いろんなことに挑戦するチャンスが多くあるので、自分も入社時より成長した気がします。
                </Interviewee>
                <Interviewer>
                  普段はどのような雰囲気・服装でお仕事をされていますか？
                </Interviewer>
                <Interviewee>
                  服装は、社外の方と打ち合わせがある時はジャケットを着ますが、普段はオフィスカジュアルです。
                </Interviewee>
                <div className="relative aspect-1.91/1">
                  <Image
                    src={voicePhotoB}
                    alt="【Voices: メンバーの声 No.4】 インタビューカット"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <Interviewer>
                  バランスボールに座って仕事していますよね？
                </Interviewer>
                <Interviewee>
                  見られちゃいましたか？（笑）バランスボールに座って仕事しています。人と違うことをしても咎められない自由な雰囲気があるので、バランスボールに座っていても大丈夫です！（笑）
                </Interviewee>
                <Interviewer>
                  仕事で充実しているな、と思う瞬間はどんな時ですか？
                </Interviewer>
                <Interviewee>
                  そうですね･･･複数のタスクを扱っている時、集中しているので充実感があります。マンネリしないというか･･･。それに計画的にタスクを遂行するのが私は楽しいです。
                </Interviewee>
                <Interviewer>
                  仕事以外ではどんな事をして過ごしていますか？
                </Interviewer>
                <Interviewee>
                  最近はまっているのは、植物かなぁ？プランターで観賞用の植物を育てていますが、いつかは食べれるものも育ててみようかな。あ、この間会社のみんなで山登りに行きました。私は途中で疲れて登れなくて、モノレールに乗ってしまいました…（笑）でも皆は、最後まで登り切ってました。すごいですよね。
                </Interviewee>
                <Interviewer>
                  最後に、一緒に働いてみたいと思う人を教えてください。
                </Interviewer>
                <Interviewee>
                  いろんなことに取り組んでみたいと思っている人です！
                </Interviewee>
                <div className="flex justify-end px-8 md:px-0">
                  <TLink href="/careers/" variant="mono" color="ff">
                    Carrers top
                  </TLink>
                </div>
              </div>
              <VoiceNav />
            </Inner>
          </Container>
        </main>
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
